import { Types } from '../actions/defectActions';
import convertArrayToObject from '../../utils/arrayOp';
import { sc } from '../../utils/Common'
const initialState = {
  filterKey: "",
  filtered: [],
  loading: false,
  error: '',
  selected: [],
  Data: [],
};

export const defectReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_DEFECT_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case Types.RESET_DEFECTS: {
      return {
        ...initialState,
        loading: false,
      };
    }

    case Types.ADD_DEFECTS: {
      return {
        ...state,
        selected: action.payload.defects,
      };
    }

    case Types.GET_DEFECT_SUCCESS: {
      return {
        ...state,
        // ...action.payload,
        error: '',
        filtered: action.payload,
        loading: false,
        defectsTable: convertArrayToObject(action.payload, 'Code'),
        Data: action.payload,
      };
    }
    case Types.SET_DEFECT_ERROR: {
      return {
        ...state,
        ...action.payload,
        error: action.payload.error,
        loading: false
      };
    }
    case Types.SET_SELECTION: {
      return {
        ...state,
        selected: [...action.payload.item]

      };
    }
    case Types.SET_CURRENT_DEFECT: {
      return {
        ...state,
        currentDefect: action.payload.value
      };
    }
    case Types.SET_DEFECT_FILTER_KEY: {
      const key = action.payload.value;
      const newFiltered = key.length === 0 ? state.Data : state.Data.filter((row) => (sc(row.UserCode, key) || sc(row.DefectDesc, key)))
      return {
        ...state,
        filterKey: key,
        filtered: newFiltered
      };
    }
    default:
      return state;
  }
};
